import { CameraCondition, CameraPurchaseCondition } from './constants';

const attributes = {

  camera_type: {
    friendly: 'Type',
    validations: {
      maxLength: 255,
    },
  },

  camera_manufacturer: {
    friendly: 'Manufacturer',
    validations: {
      maxLength: 255,
    },
  },

  camera_model: {
    friendly: 'Model',
    validations: {
      maxLength: 255,
    },
  },

  camera_year_produced: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },

  camera_country_of_origin: {
    friendly: 'Country',
    validations: {
      maxLength: 255,
    },
  },

  camera_lens: {
    friendly: 'Lens',
    validations: {
      maxLength: 255,
    },
  },

  camera_case: {
    friendly: 'Case',
    validations: {
      maxLength: 255,
    },
  },

  camera_accessories: {
    friendly: 'Accessories',
    validations: {
      maxLength: 255,
    },
  },

  camera_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: CameraCondition,
    },
  },

  camera_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: CameraPurchaseCondition,
    },
  },

  camera_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 255,
    },
  },

  camera_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 255,
    },
  },

};
export default attributes;

export const CameraDefaultSplitAttribute = 'camera_type';

export const CameraItemSearchAttributes = [];

export const CameraOverviewAttributes = ['title', 'camera_manufacturer', 'camera_model', 'camera_year_produced', 'camera_country_of_origin',
  'camera_condition', 'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const CameraSpecificationAttributes = ['camera_lens', 'camera_case', 'camera_accessories', 'camera_dimensions', 'camera_weight'];

export const CameraPurchaseAttributes = ['purchase_date', 'purchase_price', 'camera_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const CameraDetailAttributes = [];

export const CameraRequiredAttributes = [];

export const CameraDisplayAttributes = ['camera_type', 'camera_manufacturer', 'camera_model', 'camera_year_produced', 'camera_country_of_origin', 'tags'];

export const CameraSliderGalleryAttributes = {
  titleKey: 'camera_type',
  subtitleKey: 'camera_manufacturer',
};



// WEBPACK FOOTER //
// ./src/config/cameraDataAttributes.js